export const STOCKTAKE_UPDATE_CHANNEL = "yq-stocktake-updates";

export type StocktakeDocumentSide = "sale" | "purchase";

export function stocktakeIdFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/stocktakes\/([^/]+)\/?$/);
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
}

export function stocktakeTabOpenArguments(stocktakeId: string): [url: string, target: string] {
  return [
    `/stocktakes/${encodeURIComponent(stocktakeId)}`,
    `yq-stocktake-${stocktakeId.replace(/[^a-zA-Z0-9_-]/g, "-")}`,
  ];
}

export function returnableDocumentHistoryPath(type: StocktakeDocumentSide, query = "") {
  const params = new URLSearchParams({
    type,
    returnable: "true",
    limit: "100",
    q: query.trim(),
  });
  return `/documents/history?${params.toString()}`;
}

export function referencedOriginalDocumentIds(documents: Array<{ originalDocumentId?: unknown }>) {
  return new Set(
    documents
      .map((document) => document.originalDocumentId)
      .filter((id): id is string => typeof id === "string" && id.length > 0),
  );
}

export function publishStocktakeUpdate(stocktakeId: string, reason: string) {
  if (typeof BroadcastChannel === "undefined") return;
  const channel = new BroadcastChannel(STOCKTAKE_UPDATE_CHANNEL);
  channel.postMessage({ stocktakeId, reason, occurredAt: new Date().toISOString() });
  channel.close();
}
